import React, { useEffect, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { Loader2 } from "lucide-react";
import { Toaster } from "./components/ui/toaster";

// Always load these (needed for all pages)
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import LHRRedirect from "./pages/LHRRedirect"; // Load immediately to avoid double loading

// Lazy load page components
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsConditions = lazy(() => import("./pages/TermsConditions"));

// Lazy load home page sections
const HeroSection = lazy(() => import("./components/HeroSection"));
const AboutSection = lazy(() => import("./components/AboutSection"));
const TreatmentsSection = lazy(() => import("./components/TreatmentsSection"));
const GallerySection = lazy(() => import("./components/GallerySection"));
const TestimonialsSection = lazy(() => import("./components/TestimonialsSection"));
const WhyChooseUsSection = lazy(() => import("./components/WhyChooseUsSection"));
const InstagramSection = lazy(() => import("./components/InstagramSection"));
// const OffersSection = lazy(() => import("./components/OffersSection"));
const FAQSection = lazy(() => import("./components/FAQSection"));
const ContactSection = lazy(() => import("./components/ContactSection"));

// Loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50">
    <div className="text-center">
      <Loader2 className="w-12 h-12 animate-spin text-blue-600 mx-auto mb-4" />
      <p className="text-gray-600 text-lg">Loading...</p>
    </div>
  </div>
);

// Home Page Component
function HomePage() {
  const location = useLocation();

  useEffect(() => {
    // Check if there's a scrollTo section in the location state
    if (location.state?.scrollTo) {
      // Small delay to ensure the page has rendered
      setTimeout(() => {
        const element = document.querySelector(location.state.scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <>
      <Header />
      <Suspense fallback={<PageLoader />}>
        <HeroSection />
        <AboutSection />
        <TreatmentsSection />
        {/* <TreatmentPackagesSection /> */}
        <GallerySection />
        <TestimonialsSection />
        <WhyChooseUsSection />
        <InstagramSection />
        {/* <OffersSection /> */}
        <FAQSection />
        {/* <BlogSection /> */}
        <ContactSection />
      </Suspense>
      <Footer />
      <FloatingButtons />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Toaster />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/lhr" element={<LHRRedirect />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
